export default "__VITE_ASSET__CVSW_vym__"